import { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import './error.scss';
import { ErrorCodeEnum } from '../../enums/errorCode';

interface IErrorComponentProps {
    errorCode?: ErrorCodeEnum;
    errorDesc?: string;
}

const ErrorComponent = (props: IErrorComponentProps) =>  {
    const { t } = useTranslation('browser');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorDesc, setErrorDesc] = useState(props?.errorDesc);
    const [showErrorIcon, setShowErrorIcon] = useState(true);

    useEffect(() => {
        updateErrorCode(props?.errorCode || ErrorCodeEnum.NotFound);
    })

    const updateErrorCode  = (errorCode: ErrorCodeEnum) => {
        if (window.location.hash === '429') {
            errorCode = ErrorCodeEnum.TooManyRequests;
        }
        switch (errorCode) {
            case ErrorCodeEnum.None:
                break;
            case ErrorCodeEnum.ResourceProviderUnreachable:
                setErrorMessage('ERROR_UNREACHABLE_HEADER');
                setErrorDesc('ERROR_UNREACHABLE_DESC');
                break;
            case ErrorCodeEnum.ConnectionClosed:
                setErrorMessage('ERROR_CONNECTIONCLOSED_HEADER');
                setErrorDesc('ERROR_CONNECTIONCLOSED_DESC');
                break;
            case ErrorCodeEnum.NativeClient:
                setShowErrorIcon(false);
                setErrorMessage('ERROR_NATIVECLIENT_HEADER');
                setErrorDesc('ERROR_NATIVECLIENT_DESC');
                break;
            case ErrorCodeEnum.Custom:
                setErrorMessage('ERROR_CUSTOM_HEADER')
                setErrorDesc(errorDesc);
                break;
            case ErrorCodeEnum.PaymentRequired:
                setErrorMessage('ERROR_PAYMENTREQUIRED_HEADER');
                setErrorDesc('ERROR_PAYMENTREQUIRED_DESC');
                break;
            case ErrorCodeEnum.NotFound:
                setErrorMessage('ERROR_NOTFOUND_HEADER');
                setErrorDesc('ERROR_NOTFOUND_DESC');
                break;
            case ErrorCodeEnum.TooManyRequests:
                setErrorMessage('ERROR_TOOMANYREQUESTS_HEADER');
                setErrorDesc('ERROR_TOOMANYREQUESTS_DESC');
                break;
            case ErrorCodeEnum.Unauthorized:
                setErrorMessage('ERROR_UNAUTHORIZEDACCESS_HEADER');
                setErrorDesc('ERROR_UNAUTHORIZEDACCESS_DESC');
                break;
            case ErrorCodeEnum.ResourceNotFound:
                setErrorMessage('ERROR_CATALOGNOTFOUND_HEADER');
                setErrorDesc('ERROR_CATALOGNOTFOUND_DESC');
                break;
            default:
                setErrorMessage('ERROR_DEFAULT_HEADER');
                setErrorDesc('ERROR_DEFAULT_DESC');
                break;
        }
    }

    return (
        <div className="error-component-container">
            { showErrorIcon && <img src="/media/Error_Icon.svg" alt="error-png"/> }
            <p className='error-header'>{ t(`${errorMessage}`) } </p>
            <p className="error-description">{ t(`${errorDesc}`) }</p>
        </div>
    )
}

export default ErrorComponent;